import { AppQueryNetworkStatus, ReduxListener } from '../../../types';

import { researchTaskStatusCheck } from '../../actions';
import { dataSlice, networkSlice } from '../../slices';
import { getAdwordsQuestions } from '../../thunks';

const dataActions = dataSlice.actions;
const networkActions = networkSlice.actions;

const listeners = (startListening: ReduxListener) => {
  startListening({
    actionCreator: getAdwordsQuestions.pending,
    effect: async (action, { dispatch }) => {
      await dispatch(
        networkActions.adwordsQuestionsSet(AppQueryNetworkStatus.loading),
      );
    },
  });

  startListening({
    actionCreator: getAdwordsQuestions.rejected,
    effect: async (action, { dispatch }) => {
      const { aborted } = action.meta;
      if (!aborted) {
        await Promise.all([
          dispatch(
            networkActions.adwordsQuestionsSet(AppQueryNetworkStatus.error),
          ),
          dispatch(
            networkActions.inventoryTopicsQuestionsSet(
              AppQueryNetworkStatus.inactive,
            ),
          ),
        ]);

        // check status after other steps
        await dispatch(researchTaskStatusCheck());
      }
    },
  });

  startListening({
    actionCreator: getAdwordsQuestions.fulfilled,
    effect: async ({ payload }, { dispatch }) => {
      await Promise.all([
        dispatch(dataActions.adwordsQuestionsSet(payload.data)),
        dispatch(
          networkActions.adwordsQuestionsSet(AppQueryNetworkStatus.complete),
        ),
      ]);

      // check status after other steps
      await dispatch(researchTaskStatusCheck());
    },
  });
};

export default listeners;
